<template>
  <section v-show="active" class="app-modal__section">
    <div class="app-modal__section-head">
      <h4>{{ text.modal.form.classification.title }}</h4>
      <p>{{ text.modal.form.classification.subtitle }}</p>
    </div>

    <div class="app-modal__grid two-columns">
      <div class="app-modal-field">
        <span>{{ text.modal.form.classification.fields.type }}</span>
        <multiselect
          v-model="form.customerType"
          :options="customerTypeOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="240"
          :placeholder="text.filters.fields.type.placeholder"
          class="app-modal-select app-select"
        >
          <template #noResult>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
        </multiselect>
      </div>

      <div class="app-modal-field">
        <span>{{ text.modal.form.classification.fields.size }}</span>
        <multiselect
          v-model="form.size"
          :options="sizeOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="240"
          :placeholder="text.filters.fields.size.placeholder"
          class="app-modal-select app-select"
        >
          <template #noResult>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
        </multiselect>
      </div>

      <div class="app-modal-field">
        <span>{{ text.modal.form.classification.fields.sector }}</span>
        <multiselect
          v-model="form.sector"
          :options="sectorOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="240"
          :placeholder="text.filters.fields.sector.placeholder"
          class="app-modal-select app-select"
        >
          <template #noResult>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
        </multiselect>
      </div>

      <div class="app-modal-field">
        <span>{{ text.modal.form.classification.fields.origin }}</span>
        <multiselect
          v-model="form.source"
          :options="originOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="240"
          :placeholder="text.filters.fields.origin.placeholder"
          class="app-modal-select app-select"
        >
          <template #noResult>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
        </multiselect>
      </div>

      <div v-if="canAssignArea" class="app-modal-field full-width">
        <span>{{ text.modal.form.classification.fields.area }}</span>
        <multiselect
          v-model="form.area"
          :options="areaOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="240"
          :placeholder="text.filters.fields.area.placeholder"
          class="app-modal-select app-select"
        >
          <template #noResult>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
          <template #noOptions>
            <span>{{ text.common.noOptionAvailable }}</span>
          </template>
        </multiselect>
      </div>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('customers');

export default {
  name: 'CustomerSectionClassification',
  props: {
    active: { type: Boolean, default: false },
    form: { type: Object, required: true },
    customerTypeOptions: { type: Array, default: () => [] },
    sizeOptions: { type: Array, default: () => [] },
    sectorOptions: { type: Array, default: () => [] },
    originOptions: { type: Array, default: () => [] },
    areaOptions: { type: Array, default: () => [] },
    canAssignArea: { type: Boolean, default: false },
  },
  data() {
    return {
      text,
    };
  },
};
</script>
